import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreateBillableMetric } from 'src/features/billableMetrics/api/useCreateBillableMetric';
import { LIST_BILLABLE_METRICS_RESOURCE } from 'src/features/billableMetrics/api/useListBillableMetrics';
import BillableMetricFormModal from 'src/features/billableMetrics/components/forms/BillableMetricFormModal';
import { billableMetricsMessages } from 'src/features/billableMetrics/utils/messages';

interface CreateBillableMetricFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateBillableMetricFormModal<TData>({ className, semantics }: CreateBillableMetricFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateBillableMetric({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_BILLABLE_METRICS_RESOURCE] });
            toast({
                title: formatMessage(billableMetricsMessages.createBillableMetricSuccess),
                description: formatMessage(billableMetricsMessages.createBillableMetricSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <BillableMetricFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(billableMetricsMessages.addBillableMetricSubtitle)}
        />
    );
}

export default CreateBillableMetricFormModal;
